<template>
  <b-modal :visible="isOpen"
           lazy
           centered
           ok-variant="ls order-button-text"
           :ok-disabled="disableOk"
           ok-title-html="Zamów"
           cancel-title="Anuluj"
           title="Potwierdzenie zamówienia"
           @ok="orderReward"
           @hidden="clearModal"
           size="lg">
    <b-alert :show="warningMessage.length" fade variant="warning">
      <i class="fa fa-lg fa-exclamation-circle"></i>
      {{ warningMessage }}
    </b-alert>

    <div v-if="stateOrder" class="form-group d-flex flex-row">
      <b-img v-if="stateOrder.picture" :src="stateOrder.picture" height="100" class="m--padding-right-15"></b-img>
      <div>
        <h4>{{ stateOrder.name }}</h4>
        <p v-if="stateOrder.points>0">
          {{pointsName}}, które zostaną wykorzystane:
          <span class="m-badge m-badge--wide m-badge--ls">{{ stateOrder.points }} {{pointsSymbol}}</span>
        </p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
  import PushIfExists from "@/mixins/pushIfExists";

  export default {
    name: "OrderDigitalRewardModal",
    mixins: [PushIfExists],
    data() {
      return {
        disableOk: false,
        warningMessage: "",
      }
    },
    methods: {
      ...mapActions([
        'clearDigitalOrder',
        'clearVariantsOrder',
        'fetchUser',
        'fetchNavigation',
        'setDigitalOrderModalId',
        'clearVariantsOrderModalId',
        'setDelayDigitalRewardModal'
      ]),
      clearModal() {
        this.clearDigitalOrder();
        this.clearVariantsOrder();
        this.clearVariantsOrderModalId();
        this.warningMessage = "";
        this.disableOk = false;
      },
      orderReward(e) {
        e.preventDefault();
        this.warningMessage = "";
        this.disableOk = true;

        this.$http.post('/rewards', {
            rewardId: this.stateOrder.id,
          })
            .then((r) => {
              this.disableOk = false;
              if (r.data.success) {
                this.fetchUser();
                this.fetchNavigation();
                this.clearModal();

                if (this.getMatchingRoute({name: 'ReceivedRewardsPage'})) {
                  this.setDelayDigitalRewardModal(true);
                }

                this.pushIfExists({name: 'ReceivedRewardsPage'});
                this.setDigitalOrderModalId(r.data.orderId)
              } else {
                this.warningMessage = r.data.message;
              }
            })

      }
    },
    computed: {
      ...mapState({
        isOpen: state => state.rewards.digitalOrder !== null,
        stateOrder: state => state.rewards.digitalOrder,
        stateUser: state => state.auth.user,
        pointsConfig: state => state.settings.points,
        pointsSymbol() {
          return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
        },
        pointsName() {
          const name = this.pointsConfig.name ? this.pointsConfig.name : 'punkty';

          return name.charAt(0).toUpperCase() + name.slice(1);
        }
      }),
      ...mapGetters([
        'getMatchingRoute'
      ])
    }
  }
</script>

<style scoped>

</style>
